module.exports = __webpack_public_path__ + "img/insta-2.6db364e1.png";